import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import TourBulkUpdateRepository from "~/repository/Tour/TourBulkUpdateRepository";

class TourBulkUpdateStore extends NestStore {
  tourBulkUpdateRepository = null;

  constructor() {
    super();

    this.tourBulkUpdateRepository = new TourBulkUpdateRepository();
  }

  @action
  update(data) {
    this.isSaving = true;

    return this.tourBulkUpdateRepository
      .update(this.locale, data)
      .then(() => {
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }
}

export default TourBulkUpdateStore;
